import React from 'react';
import PropTypes from 'prop-types';

import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

export default function CompanyOfficeRow({ companyOffice, showOfficeName, onEdit }) {
  const {
    name, invoiceIdentifierPrefix, nextInvoiceNumber,
    backofficeInvoicePaymentInstructions, backofficeInvoiceNotes
  } = companyOffice;

  function renderWithTooltip(id, content) {
    const tooltip = (
      <Popover className="company-office-row-tooltip" id={id}>
        {content}
      </Popover>
    );

    return (
      <OverlayTrigger
        overlay={tooltip}
        placement="top"
      >
        <div className="popover-trigger">{content}</div>
      </OverlayTrigger>
    );
  }

  function renderEmptyState(textPlacement) {
    return (
      <em className="text-muted">
        Included at the {textPlacement} of each invoice
      </em>
    );
  }

  return (
    <tr>
      {showOfficeName && <td name="office-name-cell">{name}</td>}
      <td>{invoiceIdentifierPrefix || 'None'}</td>
      <td className="next-number-cell">{nextInvoiceNumber || '1'}</td>
      <td className="remit-to-cell">
        {backofficeInvoicePaymentInstructions ? renderWithTooltip(
          'payment-instructions',
          backofficeInvoicePaymentInstructions
        ) : (renderEmptyState('top'))}
      </td>
      <td>
        {backofficeInvoiceNotes ? renderWithTooltip(
          'invoice-notes',
          backofficeInvoiceNotes
        ) : (renderEmptyState('bottom'))}
      </td>
      <td>
        <div className="clickable" name="edit" onClick={() => onEdit(companyOffice)}>
          <FontAwesomeIcon icon={faEdit} />
          <span className="ml-1">Edit</span>
        </div>
      </td>
    </tr>
  );
}

CompanyOfficeRow.propTypes = {
  companyOffice: PropTypes.shape({
    backofficeInvoiceNotes: PropTypes.string,
    backofficeInvoicePaymentInstructions: PropTypes.string,
    invoiceIdentifierPrefix: PropTypes.string,
    name: PropTypes.string,
    nextInvoiceNumber: PropTypes.number,
  }),
  showOfficeName: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
};
